import * as stylex from '@stylexjs/stylex'
import type { CSSProperties } from 'react'
import { useState } from 'react'

import SettleUpLogo, { WalletMark } from '../../components/SettleUpLogo'


const styles = stylex.create({
  s0: {
    display: "flex",
    alignItems: "start",
    gap: "16px",
  },
  s1: {
    display: "flex",
    height: "48px",
    width: "48px",
    flexShrink: "0",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "1rem",
    backgroundColor: "#edf4e9",
    color: "#54855f",
  },
  s2: {
    marginBottom: "4px",
    fontSize: "13px",
    fontWeight: 600,
    color: "#262626",
  },
  s3: {
    maxWidth: "192px",
    fontSize: "12px",
    lineHeight: "1.65",
    color: "#58606a",
  },
  s4: {
    marginTop: "12px",
    height: "32px",
    width: "100%",
  },
  s5: {
    pointerEvents: "none",
    position: "absolute",
    bottom: "13%",
    right: "-2%",
    display: "none",
    height: "61%",
    width: "55%",
    "@media (min-width: 1024px)": {
      display: "block",
    },
  },
  s6: {
    position: "absolute",
    insetInline: "15%",
    top: "0px",
    height: "64px",
    transform: "rotate(10deg)",
    borderTopLeftRadius: "26px",
    borderTopRightRadius: "26px",
    backgroundColor: "#7da482",
  },
  s7: {
    position: "absolute",
    insetInline: "2%",
    top: "9%",
    height: "75%",
    transform: "rotate(8deg)",
    borderRadius: "22px",
    backgroundColor: "#c0915a",
    boxShadow: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
  },
  s8: {
    position: "absolute",
    left: "2%",
    top: "6%",
    width: "96%",
    transform: "rotate(7deg)",
    borderRadius: "20px",
    borderWidth: 1,
    borderColor: "#e7e8e2",
    backgroundColor: "#fff",
    padding: "20px",
    boxShadow: "0 20px 45px rgba(65,77,56,.16)",
  },
  s9: {
    marginBottom: "16px",
    fontSize: "1rem",
    fontWeight: 600,
    fontStyle: "italic",
  },
  s10: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: "12px",
  },
  s11: {
    borderRadius: "0.75rem",
    borderWidth: 1,
    borderColor: "#e4e7e2",
    padding: "12px",
    boxShadow: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
  },
  s12: {
    fontSize: "10px",
  },
  s13: {
    fontSize: "1.25rem",
    color: "#51865f",
  },
  s14: {
    fontSize: "10px",
    color: "#727982",
  },
  s15: {
    fontSize: "1.25rem",
    color: "#a36a31",
  },
  s16: {
    marginBottom: "8px",
    marginTop: "16px",
    fontSize: "0.875rem",
    fontWeight: 600,
    fontStyle: "italic",
  },
  s17: {
    display: "flex",
    flexDirection: "column",
    rowGap: "8px",
  },
  s18: {
    display: "grid",
    gridTemplateColumns: "28px 1fr auto auto",
    alignItems: "center",
    gap: "8px",
    fontSize: "9px",
  },
  s19: {
    display: "block",
    fontSize: "10px",
  },
  s20: {
    color: "#777",
  },
  s21: {
    fontSize: "11px",
  },
  s22: {
    position: "absolute",
    bottom: "0px",
    left: "-3%",
    width: "89%",
    transform: "rotate(8deg)",
    borderRadius: "22px",
    borderWidth: 1,
    borderColor: "#e3e6df",
    backgroundColor: "#fff",
    padding: "20px",
    boxShadow: "0 18px 35px rgba(65,77,56,.14)",
  },
  s23: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  s24: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  s25: {
    height: "28px",
    width: "28px",
    color: "#54855f",
  },
  s26: {
    display: "block",
    fontSize: "0.875rem",
  },
  s27: {
    color: "#697078",
  },
  s28: {
    textAlign: "right",
    fontSize: "0.75rem",
  },
  s29: {
    marginLeft: "20px",
    fontSize: "0.875rem",
  },
  s30: {
    marginTop: "16px",
    height: "8px",
    overflow: "hidden",
    borderRadius: "9999px",
    backgroundColor: "#e8e9e6",
  },
  s31: {
    height: "100%",
    width: "72%",
    borderRadius: "9999px",
    backgroundColor: "#5b9167",
  },
  s32: {
    marginTop: "8px",
    display: "flex",
    justifyContent: "space-between",
    fontSize: "0.75rem",
  },
  s33: {
    color: "#737a81",
  },
  s34: {
    position: "relative",
    minHeight: "680px",
    overflow: "hidden",
    backgroundImage: "radial-gradient(circle at 72% 3%,rgba(139,175,133,.18) 0 1px,transparent 2px),linear-gradient(140deg,#fffdfa 0%,#fbfcf8 48%,#eef3e9 100%)",
    backgroundSize: "18px 18px,auto",
    paddingInline: "clamp(2rem,5.5vw,5.25rem)",
    paddingBlock: "clamp(2.5rem,6vh,4.5rem)",
    "@media (min-width: 1024px)": {
      minHeight: "0px",
    },
  },
  s35: {
    position: "absolute",
    height: "384px",
    width: "384px",
    borderRadius: "9999px",
    borderWidth: "45px",
    borderColor: "color-mix(in srgb, #fff 50%, transparent)",
  },
  s36: {
    position: "relative",
    zIndex: "10",
    maxWidth: "440px",
  },
  s37: {
    marginBottom: "40px",
    transformOrigin: "left",
    transform: "scale(1.2)",
  },
  s38: {
    fontSize: "clamp(1.7rem,2.4vw,2.15rem)",
    fontWeight: 700,
    lineHeight: "1.12",
    letterSpacing: "-.035em",
    color: "#222",
  },
  s39: {
    color: "#4d815c",
  },
  s40: {
    marginTop: "16px",
    maxWidth: "350px",
    fontSize: "14px",
    lineHeight: "1.6",
    color: "#58606a",
  },
  s41: {
    marginTop: "36px",
    display: "flex",
    flexDirection: "column",
    rowGap: "28px",
  },
  s42: {
    height: "28px",
    width: "28px",
  },
  s46: {
    height: "20px",
    width: "20px",
  },
  s47: {
    minHeight: "100vh",
    width: "100%",
    backgroundColor: "#f4f5f3",
    padding: "4px",
  },
  s48: {
    display: "grid",
    minHeight: "calc(100vh - 8px)",
    width: "100%",
    gridTemplateColumns: "minmax(0,1fr)",
    overflow: "hidden",
    borderRadius: "23px",
    borderWidth: 1,
    borderColor: "#dfe2dd",
    backgroundColor: "#fff",
    boxShadow: "0 1px 8px rgba(44,55,45,.08)",
    "@media (min-width: 1024px)": {
      gridTemplateColumns: "58.5% 41.5%",
    },
  },
  s49: {
    display: "flex",
    minWidth: "0px",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    backgroundImage: "linear-gradient(145deg,#fff 0%,#fcfdfb 100%)",
    paddingInline: "16px",
    paddingBlock: "32px",
    "@media (min-width: 640px)": {
      paddingInline: "24px",
      paddingBlock: "48px",
    },
    "@media (min-width: 1024px)": {},
  },
  s50: {
    width: "100%",
    maxWidth: "426px",
    borderRadius: "19px",
    borderWidth: 1,
    borderColor: "#e0e4df",
    backgroundColor: "#fff",
    paddingInline: "clamp(1.6rem,3.2vw,2.4rem)",
    paddingBlock: "40px",
    boxShadow: "0 6px 18px rgba(50,65,52,.05)",
  },
  s51: {
    marginInline: "auto",
    display: "flex",
    height: "104px",
    width: "104px",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "9999px",
    backgroundColor: "#eff5eb",
  },
  s52: {
    height: "56px",
    width: "64px",
  },
  s53: {
    marginTop: "12px",
    textAlign: "center",
    fontSize: "28px",
    fontWeight: 700,
    letterSpacing: "-.025em",
    color: "#262626",
  },
  s54: {
    marginTop: "4px",
    textAlign: "center",
    fontSize: "15px",
    color: "#697078",
  },
  s55: {
    marginTop: "28px",
  },
  s56: {
    marginBottom: "8px",
    display: "block",
    fontSize: "14px",
    fontWeight: 600,
  },
  s57: {
    display: "flex",
    height: "49px",
    alignItems: "center",
    gap: "12px",
    borderRadius: "7px",
    borderWidth: 1,
    borderColor: "#d9ddda",
    paddingInline: "12px",
    color: "#747b83",
    ":focus-within": {
      borderColor: "#5a8f66",
      boxShadow: "0 0 0 1px color-mix(in srgb, #5a8f66 15%, transparent)",
    },
  },
  s58: {
    minWidth: "0px",
    flex: "1 1 0%",
    borderWidth: 0,
    backgroundColor: "transparent",
    fontSize: "14px",
    color: "#2c302f",
    outline: "none",
    "::placeholder": {
      color: "#8b9198",
    },
  },
  s59: {
    marginBottom: "8px",
    marginTop: "20px",
    display: "block",
    fontSize: "14px",
    fontWeight: 600,
  },
  s60: {
    borderRadius: "0.25rem",
    padding: "4px",
    ":hover": {
      backgroundColor: "#f1f4ef",
    },
    ":focus-visible": {
      outlineWidth: 2,
      outlineColor: "#5a8f66",
    },
  },
  s61: {
    marginBlock: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    fontSize: "13px",
  },
  s62: {
    display: "flex",
    cursor: "pointer",
    alignItems: "center",
    gap: "8px",
    color: "#676d73",
  },
  s63: {
    height: "20px",
    width: "20px",
    borderRadius: "0.25rem",
    borderColor: "#bfc5c1",
    accentColor: "#568a62",
  },
  s64: {
    fontWeight: 500,
    color: "#4f865d",
    textDecoration: "none",
    ":hover": {
      textDecoration: "underline",
    },
  },
  s65: {
    marginBottom: "16px",
    borderRadius: "0.5rem",
    backgroundColor: "#fff1eb",
    paddingInline: "12px",
    paddingBlock: "10px",
    fontSize: "12px",
    color: "#a44e20",
  },
  s66: {
    display: "flex",
    height: "49px",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    borderRadius: "7px",
    backgroundColor: "#568b62",
    fontSize: "15px",
    fontWeight: 500,
    color: "#fff",
    boxShadow: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
    transition: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
    ":hover": {
      backgroundColor: "#477a53",
    },
    ":focus-visible": {
      outlineWidth: 2,
      outlineOffset: 2,
      outlineColor: "#477a53",
    },
    ":disabled": {
      cursor: "wait",
      opacity: 0.7,
    },
  },
  s67: {
    marginBlock: "20px",
    display: "flex",
    alignItems: "center",
    gap: "16px",
    fontSize: "12px",
    color: "#737a81",
  },
  s68: {
    height: "1px",
    flex: "1 1 0%",
    backgroundColor: "#e5e7e4",
  },
  s69: {
    display: "flex",
    height: "49px",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    borderRadius: "7px",
    borderWidth: 1,
    borderColor: "#d8ddda",
    backgroundColor: "#fff",
    fontSize: "14px",
    fontWeight: 500,
    transition: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
    ":hover": {
      backgroundColor: "#f8faf7",
    },
    ":focus-visible": {
      outlineWidth: 2,
      outlineOffset: 2,
      outlineColor: "#568b62",
    },
  },
})

const loginStyles = stylex.create({
  previewPerson: { display: 'flex', height: '28px', width: '28px', alignItems: 'center', justifyContent: 'center', borderRadius: '9999px', fontSize: '8px', color: '#fff' },
  previewPersonFirst: { backgroundColor: '#677f5c' },
  previewPersonSecond: { backgroundColor: '#9c7355' },
  previewPersonThird: { backgroundColor: '#456971' },
  previewLabel: { borderRadius: '9999px', paddingInline: '8px', paddingBlock: '4px' },
  previewOwe: { backgroundColor: '#fbf0df', color: '#99632f' },
  previewOwed: { backgroundColor: '#edf6eb', color: '#4c7e58' },
})
type IconProps = {
  className?: string
  style?: CSSProperties
}

function PeopleIcon({ className = '', style }: IconProps) {
  return (
    <svg className={className || undefined} style={style} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" aria-hidden="true">
      <circle cx="9" cy="8" r="3" />
      <circle cx="17" cy="9" r="2.4" />
      <path d="M3.5 19v-1.5A4.5 4.5 0 0 1 8 13h2a4.5 4.5 0 0 1 4.5 4.5V19M15 14h1.5a4 4 0 0 1 4 4v1" />
    </svg>
  )
}

function CheckIcon({ className = '', style }: IconProps) {
  return (
    <svg className={className || undefined} style={style} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M9 4H6a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9" />
      <path d="m9 12 3 3 8-9M9 3h6v4H9z" />
    </svg>
  )
}

function Feature({ icon, title, children }: { icon: React.ReactNode; title: string; children: React.ReactNode }) {
  return (
    <div {...stylex.props(styles.s0)}>
      <div {...stylex.props(styles.s1)}>{icon}</div>
      <div>
        <h3 {...stylex.props(styles.s2)}>{title}</h3>
        <p {...stylex.props(styles.s3)}>{children}</p>
      </div>
    </div>
  )
}

function MiniChart({ color }: { color: string }) {
  return (
    <svg viewBox="0 0 160 42" {...stylex.props(styles.s4)} preserveAspectRatio="none" aria-hidden="true">
      <path d="M0 30 C12 31 16 23 27 26 S45 36 57 28 74 10 89 20s17 8 28-2 20 10 43-7" fill="none" stroke={color} strokeWidth="2" />
    </svg>
  )
}

function DashboardPreview() {
  return (
    <div {...stylex.props(styles.s5)} aria-hidden="true">
      <div {...stylex.props(styles.s6)} />
      <div {...stylex.props(styles.s7)} />
      <div {...stylex.props(styles.s8)}>
        <h3 {...stylex.props(styles.s9)}>Dashboard</h3>
        <div {...stylex.props(styles.s10)}>
          <div {...stylex.props(styles.s11)}>
            <p {...stylex.props(styles.s12)}>You owe</p>
            <strong {...stylex.props(styles.s13)}>$125.00</strong>
            <p {...stylex.props(styles.s14)}>to 2 people</p>
            <MiniChart color="#568c65" />
          </div>
          <div {...stylex.props(styles.s11)}>
            <p {...stylex.props(styles.s12)}>You are owed</p>
            <strong {...stylex.props(styles.s15)}>$320.00</strong>
            <p {...stylex.props(styles.s14)}>from 3 people</p>
            <MiniChart color="#b87736" />
          </div>
        </div>
        <h4 {...stylex.props(styles.s16)}>Recent activity</h4>
        <div {...stylex.props(styles.s17)}>
          {[
            ['JC', 'Jenny Croes', 'Lunch at Bistro Cafe', 'Owes you', '$45.00'],
            ['MT', 'Michael Tromp', 'Rent share – May', 'You owe', '$120.00'],
            ['RF', 'Rene Fingal', 'Dinner split', 'Owes you', '$500.00'],
          ].map(([initials, name, note, label, amount], index) => (
            <div {...stylex.props(styles.s18)} key={name}>
              <span {...stylex.props(loginStyles.previewPerson, index === 1 ? loginStyles.previewPersonSecond : index === 2 ? loginStyles.previewPersonThird : loginStyles.previewPersonFirst)}>{initials}</span>
              <span><b {...stylex.props(styles.s19)}>{name}</b><span {...stylex.props(styles.s20)}>{note}</span></span>
              <span {...stylex.props(loginStyles.previewLabel, label === 'You owe' ? loginStyles.previewOwe : loginStyles.previewOwed)}>{label}</span>
              <b {...stylex.props(styles.s21)}>{amount}</b>
            </div>
          ))}
        </div>
      </div>
      <div {...stylex.props(styles.s22)}>
        <div {...stylex.props(styles.s23)}>
          <div {...stylex.props(styles.s24)}><PeopleIcon {...stylex.props(styles.s25)} /><span><b {...stylex.props(styles.s26)}>Group trip</b><small {...stylex.props(styles.s27)}>4 members</small></span></div>
          <div {...stylex.props(styles.s28)}><span {...stylex.props(styles.s27)}>Balance</span><b {...stylex.props(styles.s29)}>$180.50</b></div>
        </div>
        <div {...stylex.props(styles.s30)}><div {...stylex.props(styles.s31)} /></div>
        <div {...stylex.props(styles.s32)}><b>$719.50</b><span {...stylex.props(styles.s33)}>of $900.00 settled</span></div>
      </div>
    </div>
  )
}

export function IntroPanel() {
  return (
    <section {...stylex.props(styles.s34)}>
      <div {...stylex.props(styles.s35)} />
      <div {...stylex.props(styles.s36)}>
        <SettleUpLogo {...stylex.props(styles.s37)} />
        <h1 {...stylex.props(styles.s38)}>
          Track shared expenses<br />and settle balances<br /><span {...stylex.props(styles.s39)}>with the people you trust.</span>
        </h1>
        <p {...stylex.props(styles.s40)}>Split bills, keep everyone in sync, and settle up with confidence—so nothing slips and relationships stay strong.</p>
        <div {...stylex.props(styles.s41)}>
          <Feature title="Shared expenses" icon={<PeopleIcon {...stylex.props(styles.s42)} />}>Split bills, track payments,<br />and keep everyone in sync.</Feature>
          <Feature title="Settle balances" icon={<CheckIcon {...stylex.props(styles.s42)} />}>See who owes what and<br />close the loop.</Feature>
        </div>
      </div>
      <DashboardPreview />
    </section>
  )
}

function FieldIcon({ kind }: { kind: 'email' | 'lock' }) {
  return kind === 'email' ? (
    <svg viewBox="0 0 24 24" {...stylex.props(styles.s46)} fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m4 7 8 6 8-6" /></svg>
  ) : (
    <svg viewBox="0 0 24 24" {...stylex.props(styles.s46)} fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden="true"><rect x="5" y="10" width="14" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3" /></svg>
  )
}

type LoginPageProps = {
  onSignIn?: (email: string, password: string) => Promise<void> | void
  onCreateAccount?: () => void
}

export default function LoginPage({ onSignIn, onCreateAccount }: LoginPageProps) {
  const [showPassword, setShowPassword] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [signingIn, setSigningIn] = useState(false)

  async function submit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault()
    setError('')
    setSigningIn(true)
    try {
      await onSignIn?.(email.trim(), password)
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : 'We could not sign you in. Check your details and try again.')
    } finally {
      setSigningIn(false)
    }
  }

  return (
    <main {...stylex.props(styles.s47)}>
      <div {...stylex.props(styles.s48)}>
        <IntroPanel />
        <section {...stylex.props(styles.s49)}>
          <div {...stylex.props(styles.s50)}>
            <div {...stylex.props(styles.s51)}><WalletMark {...stylex.props(styles.s52)} /></div>
            <h2 {...stylex.props(styles.s53)}>Welcome back</h2>
            <p {...stylex.props(styles.s54)}>Sign in to continue to SettleUp</p>

            <form {...stylex.props(styles.s55)} onSubmit={submit}>
              <label htmlFor="email" {...stylex.props(styles.s56)}>Email address</label>
              <div {...stylex.props(styles.s57)}>
                <FieldIcon kind="email" />
                <input id="email" type="email" autoComplete="email" placeholder="you@example.com" {...stylex.props(styles.s58)} onChange={(event) => setEmail(event.target.value)} value={email} />
              </div>

              <label htmlFor="password" {...stylex.props(styles.s59)}>Password</label>
              <div {...stylex.props(styles.s57)}>
                <FieldIcon kind="lock" />
                <input id="password" type={showPassword ? 'text' : 'password'} autoComplete="current-password" placeholder="Enter your password" {...stylex.props(styles.s58)} onChange={(event) => setPassword(event.target.value)} value={password} />
                <button type="button" aria-label={showPassword ? 'Hide password' : 'Show password'} {...stylex.props(styles.s60)} onClick={() => setShowPassword((visible) => !visible)}>
                  <svg viewBox="0 0 24 24" {...stylex.props(styles.s46)} fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden="true"><path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z" /><circle cx="12" cy="12" r="2.7" /></svg>
                </button>
              </div>

              <div {...stylex.props(styles.s61)}>
                <label {...stylex.props(styles.s62)}><input type="checkbox" {...stylex.props(styles.s63)} />Remember me</label>
                <a href="#forgot-password" {...stylex.props(styles.s64)}>Forgot password?</a>
              </div>

              {error && <p {...stylex.props(styles.s65)} role="alert">{error}</p>}
              <button disabled={signingIn} type="submit" {...stylex.props(styles.s66)}>
                <FieldIcon kind="lock" /> {signingIn ? 'Signing in…' : 'Sign in'}
              </button>

              <div {...stylex.props(styles.s67)}><span {...stylex.props(styles.s68)} />or<span {...stylex.props(styles.s68)} /></div>
              <button type="button" onClick={onCreateAccount} {...stylex.props(styles.s69)}>
                <svg viewBox="0 0 24 24" {...stylex.props(styles.s46)} fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden="true"><circle cx="10" cy="8" r="3.5" /><path d="M3.5 20v-1.5A5.5 5.5 0 0 1 9 13h2a5.5 5.5 0 0 1 5.5 5.5V20M18.5 6v6M15.5 9h6" /></svg>
                Create account
              </button>
            </form>

          </div>
        </section>
      </div>
    </main>
  )
}
